var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5ZM12 14.75C12.4142 14.75 12.75 15.0858 12.75 15.5C12.75 15.9142 12.4142 16.25 12 16.25C11.5858 16.25 11.25 15.9142 11.25 15.5C11.25 15.0858 11.5858 14.75 12 14.75ZM12 7C12.3824 7 12.6979 7.32144 12.7442 7.7369L12.75 7.84259V12.6574C12.75 13.1228 12.4142 13.5 12 13.5C11.6176 13.5 11.3021 13.1786 11.2558 12.7631L11.25 12.6574V7.84259C11.25 7.37724 11.5858 7 12 7Z",
    fill: "#AC5D0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning);
export default __webpack_public_path__ + "static/media/message-warning.ae2dc98fd79d8c878a3b19a46eebb3c4.svg";
export { ForwardRef as ReactComponent };